module.exports = __webpack_public_path__ + "static/media/tuckerAndDerekHeadshot.571b572e.png";